"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_TestScript = exports.TestScriptStatusKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_id_1 = require("../Scalar/RTTI_id");
var RTTI_Meta_1 = require("./RTTI_Meta");
var RTTI_uri_1 = require("../Scalar/RTTI_uri");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_code_1 = require("../Scalar/RTTI_code");
var RTTI_Narrative_1 = require("./RTTI_Narrative");
var RTTI_ResourceList_1 = require("../Union/RTTI_ResourceList");
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Identifier_1 = require("./RTTI_Identifier");
var RTTI_dateTime_1 = require("../Scalar/RTTI_dateTime");
var RTTI_ContactDetail_1 = require("./RTTI_ContactDetail");
var RTTI_markdown_1 = require("../Scalar/RTTI_markdown");
var RTTI_UsageContext_1 = require("./RTTI_UsageContext");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var RTTI_TestScript_Origin_1 = require("./RTTI_TestScript_Origin");
var RTTI_TestScript_Destination_1 = require("./RTTI_TestScript_Destination");
var RTTI_TestScript_Metadata_1 = require("./RTTI_TestScript_Metadata");
var RTTI_TestScript_Fixture_1 = require("./RTTI_TestScript_Fixture");
var RTTI_Reference_1 = require("./RTTI_Reference");
var RTTI_TestScript_Variable_1 = require("./RTTI_TestScript_Variable");
var RTTI_TestScript_Setup_1 = require("./RTTI_TestScript_Setup");
var RTTI_TestScript_Test_1 = require("./RTTI_TestScript_Test");
var RTTI_TestScript_Teardown_1 = require("./RTTI_TestScript_Teardown");
var TestScriptStatusKind;
(function (TestScriptStatusKind) {
    TestScriptStatusKind["_draft"] = "draft";
    TestScriptStatusKind["_active"] = "active";
    TestScriptStatusKind["_retired"] = "retired";
    TestScriptStatusKind["_unknown"] = "unknown";
})(TestScriptStatusKind = exports.TestScriptStatusKind || (exports.TestScriptStatusKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_TestScript = t.recursion('ITestScript', function () {
    return t.intersection([
        t.type({
            resourceType: t.literal('TestScript')
        }),
        t.partial({
            id: RTTI_id_1.RTTI_id,
            meta: RTTI_Meta_1.RTTI_Meta,
            implicitRules: RTTI_uri_1.RTTI_uri,
            _implicitRules: RTTI_Element_1.RTTI_Element,
            language: RTTI_code_1.RTTI_code,
            _language: RTTI_Element_1.RTTI_Element,
            text: RTTI_Narrative_1.RTTI_Narrative,
            contained: t.array(RTTI_ResourceList_1.RTTI_ResourceList),
            extension: t.array(RTTI_Extension_1.RTTI_Extension),
            modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
            url: RTTI_uri_1.RTTI_uri,
            _url: RTTI_Element_1.RTTI_Element,
            identifier: RTTI_Identifier_1.RTTI_Identifier,
            version: t.string,
            _version: RTTI_Element_1.RTTI_Element,
            name: t.string,
            _name: RTTI_Element_1.RTTI_Element,
            title: t.string,
            _title: RTTI_Element_1.RTTI_Element,
            status: (0, EnumType_1.createEnumType)(TestScriptStatusKind, 'TestScriptStatusKind'),
            _status: RTTI_Element_1.RTTI_Element,
            experimental: t.boolean,
            _experimental: RTTI_Element_1.RTTI_Element,
            date: RTTI_dateTime_1.RTTI_dateTime,
            _date: RTTI_Element_1.RTTI_Element,
            publisher: t.string,
            _publisher: RTTI_Element_1.RTTI_Element,
            contact: t.array(RTTI_ContactDetail_1.RTTI_ContactDetail),
            description: RTTI_markdown_1.RTTI_markdown,
            _description: RTTI_Element_1.RTTI_Element,
            useContext: t.array(RTTI_UsageContext_1.RTTI_UsageContext),
            jurisdiction: t.array(RTTI_CodeableConcept_1.RTTI_CodeableConcept),
            purpose: RTTI_markdown_1.RTTI_markdown,
            _purpose: RTTI_Element_1.RTTI_Element,
            copyright: RTTI_markdown_1.RTTI_markdown,
            _copyright: RTTI_Element_1.RTTI_Element,
            origin: t.array(RTTI_TestScript_Origin_1.RTTI_TestScript_Origin),
            destination: t.array(RTTI_TestScript_Destination_1.RTTI_TestScript_Destination),
            metadata: RTTI_TestScript_Metadata_1.RTTI_TestScript_Metadata,
            fixture: t.array(RTTI_TestScript_Fixture_1.RTTI_TestScript_Fixture),
            profile: t.array(RTTI_Reference_1.RTTI_Reference),
            variable: t.array(RTTI_TestScript_Variable_1.RTTI_TestScript_Variable),
            setup: RTTI_TestScript_Setup_1.RTTI_TestScript_Setup,
            test: t.array(RTTI_TestScript_Test_1.RTTI_TestScript_Test),
            teardown: RTTI_TestScript_Teardown_1.RTTI_TestScript_Teardown
        })
    ]);
});
//# sourceMappingURL=RTTI_TestScript.js.map